import { create } from "zustand";

export interface FormData {
  [formId: string]: {
    [fieldName: string]: string | number | null;
  };
}

interface FormStore {
  formData: FormData;
  updateFormField: (formId: string, fieldName: string, value: any) => void;
  initializeForm: (formId: string, initialData?: Record<string, any>) => void;
  resetForm: (formId: string) => void;
  getAllFormData: () => FormData;
}

export const useFormStore = create<FormStore>((set, get) => ({
  formData: {},

  updateFormField: (formId, fieldName, value) => {
    set((state) => ({
      formData: {
        ...state.formData,
        [formId]: {
          ...state.formData[formId],
          [fieldName]: value,
        },
      },
    }));
  },

  initializeForm: (formId, initialData = {}) => {
    set((state) => ({
      formData: {
        ...state.formData,
        [formId]: initialData,
      },
    }));
  },

  resetForm: (formId) => {
    set((state) => {
      const newFormData = { ...state.formData };
      delete newFormData[formId];
      return { formData: newFormData };
    });
  },

  getAllFormData: () => {
    return get().formData;
  },
}));
